import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { MarketingFeeDetails } from 'src/common/models';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkMark, UitkMarkSize } from 'uitk-react-mark';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';

import { DisclaimerDialog } from 'src/common/components/common/disclaimer-dialog';

const LinkTracked = ClickTracker(Link);

export interface MarketingFeeDetailsContainerProps {
  marketingFeeDetails?: MarketingFeeDetails;
  marketingFeeQuery?: any;
  marketingFeeDialogId?: string;
  handleClose?: () => void;
  alignmentClasses: string;
}

export const MarketingFeeDetailsContainer: React.FunctionComponent<MarketingFeeDetailsContainerProps> = ({
  marketingFeeDetails,
  marketingFeeQuery,
  marketingFeeDialogId,
  handleClose,
  alignmentClasses,
}) => (
  <React.Fragment>
    {marketingFeeDetails && marketingFeeDetails.tierName && (
      <div className={`uitk-grid ${alignmentClasses}`} data-stid="taap-srp-marketing-fee-info">
        <UitkMoreInfoTrigger className="all-t-padding-half all-b-padding-half">
          <LinkTracked to={marketingFeeQuery} linkName="Open SRP Commission Information Dialog" rfrr="TAAP.MarketingFee.Details">
            <UitkMark name={marketingFeeDetails.tierIcon} size={UitkMarkSize.SMALL} className="pwa-theme--grey-700 all-r-padding-one" />
            <span className="uitk-type-regular pwa-theme--grey-700 truncate">{marketingFeeDetails.tierName}</span>
            <UitkIcon name="info_outline" className="pwa-theme--grey-700" size={UitkIconSize.SMALL} />
          </LinkTracked>
        </UitkMoreInfoTrigger>
        <DisclaimerDialog
          dialogType="pwaDialog"
          disclaimerText={marketingFeeDetails.marketingFeeMessage.value}
          innerHTML={true}
          layerId="price-marketing-fee-dialog"
          disclaimerTextId="price-marketing-fee-text"
          dialogId={marketingFeeDialogId}
          handleClose={handleClose}
        />
      </div>
    )}
  </React.Fragment>
);
